module.exports = global["jQuery"] = require("-!/var/www/projects/php/vzlet.ru/frontend/node_modules/expose-loader/index.js?$!./jquery.js");